// extracted by mini-css-extract-plugin
export default {"Subscription":"Subscriptions_Subscription__2QstB","List":"Subscriptions_List__R0Zc8"};